import Vue from 'vue'
import Router from 'vue-router'
import Register from './views/login/register.vue';
import Reset from './views/login/reset.vue';
import Main from './views/main/main.vue';
import GameDetail from './views/home/GameDetail';
import IOSDemo from './download/iosdemo.vue';
import GameList from './views/home/GameList';
import Index from './views/home/Index';
import Notice from './views/home/Notice';
import Me from './views/home/Me';
import Kf from './views/home/Kf';
import SelfPay from './views/home/selfpay.vue';
import SelfPayWX from './views/home/selfpaywx.vue';
import WxJsapi from './views/home/wxjsapi.vue';
import Intro from './views/app/intro.vue';
import BindWx from './views/home/bindwx.vue';
import GameSpeedH5 from './views/home/GameSpeedH5';
import SearchGameList from './views/home/SearchGameList';
import MyGame from './views/home/MyGame.vue';
import AppPassword from './views/home/AppPassword';
import AppAbout from './views/home/AppAbout';
import AppRealName from './views/home/AppRealName';
import AppTel from './views/home/AppTel';
import AppSearch from './views/home/AppSearch.vue';
import DownloadApp from './views/home/DownloadApp.vue';
import ContentDetail from './views/home/ContentDetail.vue';
import ContentTemp from "@/views/home/ContentTemp.vue";

import TaoHuaLiGame from './views/dispatch/taohuali.vue';
import XingYouGame from './views/dispatch/xingyou.vue';

import Test from "./views/test/game";

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/home/gameList',
      name: 'GameList',
      component: GameList
    },
    {
      path: '/home/kf',
      name: 'Kf',
      component: Kf
    },
    {
      path: '/home/myGame',
      name: 'MyGame',
      component: MyGame
    },
    {
      path: '/home/notice',
      name: 'Notice',
      component: Notice
    },
    {
      path: '/home/me',
      name: 'Me',
      component: Me
    },
    {
      path: '/home/password',
      name: 'AppPassword',
      component: AppPassword
    },
    {
      path: '/home/about',
      name: 'AppAbout',
      component: AppAbout
    },
    {
      path: '/home/realName',
      name: 'AppRealName',
      component: AppRealName
    },
    {
      path: '/home/tel',
      name: 'AppTel',
      component: AppTel
    },
    {
      path: '/home/appSearch',
      name: 'AppSearch',
      component: AppSearch,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/home/app',
      name: 'DownloadApp',
      component: DownloadApp
    },
    {
      path: '/home/contentDetail',
      name: 'ContentDetail',
      component: ContentDetail
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '/h5/*/*',
      name: 'Main',
      component: Main
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/reset',
      name: 'Reset',
      component: Reset
    },
    {
      path: '/selfPay',
      name: 'SelfPay',
      component: SelfPay
    },
    {
      path: '/jiabi',
      name: 'SelfPay',
      component: SelfPay
    },
    {
      path: '/selfPayWX',
      name: 'SelfPayWX',
      component: SelfPayWX
    },
    {
      path: '/gameInfo/*/*',
      name: 'GameDetail',
      component: GameDetail
    },
    {
      path: '/download/iosGuide',
      name: 'IOSDemo',
      component: IOSDemo,
      meta: {
        title: 'IOS信任指引'
      }
    },
    {
      path: '/wxJsapi',
      name: 'WxJsapi',
      component: WxJsapi,
      meta: {
        title: '微信支付'
      }
    },
    {
      path: '/app/intro',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/bindWeChat',
      name: 'BindWx',
      component: BindWx
    },
    {
      path: '/gameSpeedH5',
      name: 'GameSpeedH5',
      component: GameSpeedH5
    },
    {
      path: '/home/searchGameList',
      name: 'SearchGameList',
      component: SearchGameList
    },
    {
      path: '/h5game/taohuali',
      name: 'TaoHuaLiGame',
      component: TaoHuaLiGame
    },
    {
      path: '/h5game/xingyou',
      name: 'XingYouGame',
      component: XingYouGame
    },
    {
      path: '/strategy',
      name: 'ContentTemp',
      component: ContentTemp
    },


  ]
})
